<template>
  <div class="tags-search-box">
    <ul  class="tags-list">
       <li v-for="(tag, index) in tags" :key="index">
           <a href @click.prevent="handleClick(tag.id)" :class="itemClass(tag.id)">{{ tag.title }}</a>
       </li>
    </ul>
    <div class="search-box">
      <form class="tags-search-form" @submit.prevent="handleSearchForm">
        <input type="text" class="form-control" placeholder="Поиск" v-model.trim="search">
        <button type="submit" class="search-btn" title="Поиск">
          <svg width="18" height="18" viewBox="0 0 18 18">
            <path d="M12.5 11H11.71L11.43 10.73C12.41 9.59 13 8.11 13 6.5C13 2.91 10.09 0 6.5 0C2.91 0 0 2.91 0 6.5C0 10.09 2.91 13 6.5 13C8.11 13 9.59 12.41 10.73 11.43L11 11.71V12.5L16 17.49L17.49 16L12.5 11ZM6.5 11C4.01 11 2 8.99 2 6.5C2 4.01 4.01 2 6.5 2C8.99 2 11 4.01 11 6.5C11 8.99 8.99 11 6.5 11Z" fill="#0FA38E"></path>
          </svg>
        </button>
      </form>
    </div>
  </div>
</template>

<script>
    export default {
        name: 'tag-search-list',
        props: ['tags', 'activeTags'],
        data() {
          return {
            search: this.$route.query.search,
          }
        },
        methods: {
            itemClass(id){
                return this.activeTags.includes(id) ? 'active' : '';
            },
            handleClick(id) {
                this.$emit('click', id);
                this.$router.push({query: {tag: this.activeTags, search: this.search}}).catch(error => {
                  if (
                      error.name !== 'NavigationDuplicated' &&
                      !error.message.includes('Avoided redundant navigation to current location')
                  ) {
                    console.log(error)
                  }
                })
            },
            handleSearchForm(e) {
              const searchString = e.target.elements[0].value

              this.search = searchString
              this.$emit('search', searchString);
              
              const query = searchString 
                  ? {query: {tag: this.activeTags, search: searchString}} 
                  : {query: {tag: this.activeTags}}
 
              this.$router.push(query).catch(error => {
                if (error.name !== 'NavigationDuplicated' && !error.message.includes('Avoided redundant navigation to current location')) {
                  console.log(error)
                }
              })
            }
        }
    }
</script>

<style scoped>
/*Tags search form*/
.tags-search-box{
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  margin: 0 0 40px;
}
.tags-search-box .tags-list{
  align-self: center;
  margin: 0 0 -11px;
  width: calc(50% - 20px);
}
.tags-search-box .search-box{
  width: calc(50% - 20px);
  max-width: 440px;
  margin: 0 0 0 auto;
}
.tags-search-form{
  position: relative;
  margin: 0;
}
.tags-search-form .form-control{
  font-weight: 400;
  font-size: 18px;
  height: 40px;
  line-height: 40px;
  color: #757F8C;
  padding: 0 58px 0 17px;
  background: transparent;
  border-color: #0fa38e;
}
.tags-search-form .form-control::-webkit-input-placeholder{
  color: #757F8C;
}
.tags-search-form .form-control::-moz-placeholder{
  color: #757F8C;
}
.tags-search-form .form-control:-ms-input-placeholder{
  color: #757F8C;
}
.tags-search-form .search-btn{
  position: absolute;
  z-index: 2;
  right: 0;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  width: 58px;
  padding: 0;
  margin: 0;
}
.no-touchevents .tags-search-form .search-btn:hover{
  opacity: .7;
}
.tags-search-form .search-btn svg{
  margin: 0 auto;
}
@media screen and (max-width: 780px){
  /*Tags search form*/
  .tags-search-box .tags-list{
    width: 100%;
    order: 2;
  }
  .tags-search-box .search-box{
    order: 1;
    width: 100%;
    max-width: 440px;
    margin: 0 0 27px;
  }
}
@media screen and (max-width: 480px){
  /*Tags search form*/
  .tags-search-form .form-control{
    font-size: 16px;
    height: 36px;
    line-height: 36px;
    padding: 0 58px 0 10px;
  }
  .tags-search-form .search-btn{
    height: 36px;
    width: 40px;
  }
}
</style>
